import { render } from "./Header.vue?vue&type=template&id=d35a3a1a"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script